import React from 'react'
import LinkButton from '../LinkButton'
import { useCLickEvent } from '@/hooks/use-tracker'

// 各アイコン
const DatabaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <rect
      x="17.33"
      y="13.4"
      width="68.7"
      height="78"
      fill="none"
      stroke-width="0"
    />
    <path
      d="m86.23,24.42v-.61c-.04-.55-.16-1.03-.34-1.51-3.44-8.87-28.8-9.31-33.85-9.31s-30.41.44-33.86,9.4c-.04.12-.06.24-.1.35-.27.5-.43,1.08-.43,1.68v55.46c0,.77.24,1.49.65,2.1,3.91,8.58,28.61,9.02,33.75,9.02,5.4,0,32.31-.5,34.16-10.35.04-.22.07-.44.07-.65.04-.24.07-.47.07-.72V25.35c0-.32-.06-.62-.13-.92h.01Zm-7.25,18.56c-3.28,1.82-12.86,4.15-26.96,4.15s-23.75-2.35-26.99-4.18v-11.34c2.38.89,5.34,1.64,8.96,2.26,5.34.8,11.59,1.23,18.04,1.23s12.65-.41,18.04-1.23c3.82-.65,6.7-1.42,8.9-2.24v11.34h0Zm-53.94,6.41c9.2,3.51,24.58,3.66,26.99,3.66s17.74-.15,26.96-3.65v11.84c-3.28,1.82-12.86,4.15-26.96,4.15s-23.75-2.35-26.99-4.18v-11.84h0Zm53.82-24.45c0,.1.03.19.04.3-1.49.81-4.46,1.92-9.76,2.82-5.06.75-10.98,1.15-17.12,1.15s-12.1-.4-17.11-1.14c-5.39-.92-8.34-2.04-9.82-2.85h0c0-.06.03-.12.04-.16v-.06c1.8-1.67,11.19-4.61,26.88-4.61s24.89,2.89,26.82,4.56h.01Zm.07,54.1c-1.87,1.67-11.26,4.58-26.88,4.58s-25.27-3-26.96-4.65c-.01-.09-.03-.18-.06-.27v-11.07c9.2,3.51,24.58,3.66,26.99,3.66s17.74-.15,26.96-3.65v11c-.03.13-.04.25-.04.38h0Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const AIIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <rect
      x="12.03"
      y="13.12"
      width="78"
      height="78"
      fill="none"
      stroke-width="0"
    />
    <path
      d="m78.94,13.12H23.13c-6.13,0-11.1,4.97-11.1,11.1v55.81c0,6.13,4.97,11.1,11.1,11.1h55.81c6.13,0,11.1-4.97,11.1-11.1V24.22c0-6.13-4.97-11.1-11.1-11.1Zm3.7,66.9c0,2.04-1.66,3.7-3.7,3.7H23.13c-2.04,0-3.7-1.66-3.7-3.7V24.22c0-2.04,1.66-3.7,3.7-3.7h55.81c2.04,0,3.7,1.66,3.7,3.7v55.81Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m47.88,38.71c-.37-1.24-1.51-2.09-2.81-2.1-1.35-.01-2.44.81-2.84,2.06l-8.79,27.25c-.5,1.55.35,3.23,1.91,3.73.3.1.61.15.9.15,1.24,0,2.41-.8,2.81-2.06l1.2-3.71c.19.04.38.06.59.06h8.02c.18,0,.36-.01.53-.06l1.11,3.65c.47,1.57,2.13,2.44,3.7,1.97,1.57-.47,2.44-2.13,1.97-3.7l-8.31-27.25h.01Zm-5.73,19.46l2.81-8.7,2.65,8.7h-5.46Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m65.82,36.31c-1.63,0-2.96,1.33-2.96,2.96v27.22c0,1.63,1.33,2.96,2.96,2.96s2.96-1.33,2.96-2.96v-27.22c0-1.63-1.33-2.96-2.96-2.96Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <rect x="13" y="13" width="78" height="78" fill="none" stroke-width="0" />
    <path
      d="m66.08,83.62H24.05c-2.03,0-3.69-1.65-3.69-3.69V24.07c0-2.04,1.65-3.69,3.69-3.69h41.82c2.03,0,3.69,1.65,3.69,3.69v9.05c0,2.04,1.65,3.69,3.69,3.69s3.69-1.65,3.69-3.69v-9.05c0-6.11-4.95-11.07-11.06-11.07H24.05c-6.1,0-11.06,4.96-11.06,11.07v55.85c0,6.11,4.95,11.07,11.06,11.07h42.03c2.03,0,3.69-1.65,3.69-3.69s-1.65-3.69-3.69-3.69Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m32.55,57.22h7.68c1.62,0,2.95-1.33,2.95-2.95s-1.33-2.95-2.95-2.95h-7.68c-1.62,0-2.95,1.33-2.95,2.95s1.33,2.95,2.95,2.95Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m32.55,69.39h8.02c1.62,0,2.95-1.33,2.95-2.95s-1.33-2.95-2.95-2.95h-8.02c-1.62,0-2.95,1.33-2.95,2.95s1.33,2.95,2.95,2.95Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m50.08,41.76c0-1.62-1.33-2.95-2.95-2.95h-14.57c-1.62,0-2.95,1.33-2.95,2.95s1.33,2.95,2.95,2.95h14.57c1.62,0,2.95-1.33,2.95-2.95Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m90.13,81.36l-9.24-9.26c3.02-3.31,4.86-7.71,4.86-12.52,0-10.28-8.34-18.63-18.6-18.63s-18.6,8.36-18.6,18.63,8.34,18.63,18.6,18.63c3.3,0,6.4-.87,9.1-2.39l9.71,9.73c.57.58,1.33.87,2.08.87s1.5-.3,2.08-.87c1.15-1.15,1.15-3.03,0-4.18h.01Zm-35.79-21.79c0-7.07,5.75-12.83,12.81-12.83s12.81,5.76,12.81,12.83-5.75,12.83-12.81,12.83-12.81-5.76-12.81-12.83Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const PuzzleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <defs>
      <mask
        id="mask"
        x="12.96"
        y="13.41"
        width="78"
        height="78"
        maskUnits="userSpaceOnUse"
      >
        <g id="mask0_11321_9427">
          <path
            d="m90.96,13.41H12.96v78h78V13.41Z"
            fill="#fff"
            stroke-width="0"
          />
        </g>
      </mask>
    </defs>
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <g mask="url(#mask)">
      <path
        d="m43.85,24.98c.59-6.2,5.8-11.05,12.15-11.05s11.58,4.86,12.15,11.05h9.98c2.94,0,5.33,2.39,5.33,5.33v17.74h-6.88c-2.35.28-4.16,2.27-4.16,4.7,0,2.61,2.13,4.74,4.74,4.74h6.32v17.06c0,2.94-2.39,5.33-5.33,5.33h-9.98c-.59,6.2-5.8,11.05-12.15,11.05s-11.58-4.86-12.15-11.05h-9.98c-2.94,0-5.33-2.39-5.33-5.33v-10.04c-6.2-.59-11.05-5.8-11.05-12.15s4.86-11.58,11.05-12.15v-9.88c0-2.94,2.39-5.33,5.33-5.33h9.98-.01Zm32.15,15.61c-6.2.59-11.05,5.8-11.05,12.15s4.86,11.58,11.05,12.15v7.49h-15.25v6.32c0,2.61-2.13,4.74-4.74,4.74s-4.74-2.13-4.74-4.74v-6.32h-15.25v-15.31h-6.32c-2.61,0-4.74-2.13-4.74-4.74s2.13-4.74,4.74-4.74h6.32v-15.15h15.25v-6.32c0-2.61,2.13-4.74,4.74-4.74s4.74,2.13,4.74,4.74v6.32h15.25v8.14h0Z"
        fill="#c8bda8"
        fill-rule="evenodd"
        stroke-width="0"
      />
    </g>
  </svg>
)

const HistoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <path
      d="m54.18,30.16c2.08,0,3.78,1.7,3.78,3.78v19.61l12.54,6.27c1.88.94,2.62,3.2,1.7,5.08-.94,1.88-3.22,2.62-5.08,1.7l-14.64-7.31c-1.28-.64-2.1-1.95-2.1-3.38v-21.95c0-2.08,1.7-3.78,3.78-3.78h.01Z"
      fill="#c8bda8"
      fill-rule="evenodd"
      stroke-width="0"
    />
    <path
      d="m68.99,27.54c-5.3-2.92-11.41-4.04-17.39-3.19-5.99.85-11.54,3.62-15.83,7.91-.03.03-.06.06-.09.07l-9.37,8.82h11.59c2.08,0,3.78,1.7,3.78,3.78s-1.7,3.78-3.78,3.78h-21.07c-.49,0-.98-.09-1.44-.27-.49-.19-.95-.51-1.34-.91-.04-.04-.09-.09-.12-.13-.25-.3-.45-.61-.6-.95-.21-.46-.31-.98-.31-1.52v-21.13c0-2.08,1.7-3.78,3.78-3.78s3.78,1.7,3.78,3.78v12.37l9.89-9.31c5.42-5.42,12.46-8.93,20.06-10.01,7.62-1.09,15.38.34,22.11,4.07,6.73,3.71,12.09,9.52,15.23,16.54,3.16,7.01,3.93,14.88,2.23,22.38-1.7,7.5-5.79,14.25-11.66,19.22-5.87,4.97-13.19,7.91-20.88,8.35s-15.29-1.61-21.71-5.87c-6.4-4.26-11.26-10.48-13.82-17.74-.7-1.97.34-4.14,2.31-4.82,1.97-.7,4.14.34,4.82,2.31,2.01,5.7,5.84,10.6,10.87,13.95,5.05,3.35,11.03,4.97,17.08,4.62,6.05-.36,11.81-2.67,16.42-6.58,4.62-3.92,7.83-9.22,9.17-15.13,1.34-5.9.71-12.08-1.76-17.6-2.47-5.52-6.69-10.08-11.99-13.01h.01Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const CompareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <path
      d="m89.93,26.61l-12.54-12.54c-.69-.69-1.62-1.07-2.6-1.07h-24.5c-6.08,0-11.01,4.93-11.01,11.01v5.65h-15.26c-6.08,0-11.01,4.93-11.01,11.01v39.32c0,6.08,4.93,11.01,11.01,11.01h29.7c6.08,0,11.01-4.93,11.01-11.01v-5.65h15.26c6.08,0,11.01-4.93,11.01-11.01V29.21c0-.97-.38-1.91-1.07-2.6Zm-41.09,12.23l7.9,7.9h-7.9v-7.9Zm4.88,44.82h-29.7c-2.03,0-3.67-1.64-3.67-3.67v-39.32c0-2.03,1.64-3.67,3.67-3.67h18.95v12.67c0,1.62,1.32,2.94,2.94,2.94h11.48v27.38c0,2.03-1.64,3.67-3.67,3.67Zm29.95-20.34c0,2.03-1.64,3.67-3.67,3.67h-15.26v-21.12c0-.97-.38-1.91-1.07-2.6l-12.54-12.54c-.69-.69-1.62-1.07-2.6-1.07h-1.89v-5.65c0-2.03,1.64-3.67,3.67-3.67h22.97l10.4,10.4v32.59Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m30.02,54.95h5.54c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94h-5.54c-1.62,0-2.94,1.32-2.94,2.94s1.32,2.94,2.94,2.94Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m47.25,58.74h-17.23c-1.62,0-2.94,1.32-2.94,2.94s1.32,2.94,2.94,2.94h17.23c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m47.25,68.45h-17.23c-1.62,0-2.94,1.32-2.94,2.94s1.32,2.94,2.94,2.94h17.23c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const NumberIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect
      x=".08"
      y=".08"
      width="103.84"
      height="103.84"
      transform="translate(-.08 .08) rotate(-.09)"
      fill="none"
      stroke-width="0"
    />
    <path
      d="m38.94,23.22c0-2.07,1.53-3.74,3.43-3.74l45.13-.07c1.89,0,3.44,1.66,3.44,3.73s-1.53,3.74-3.43,3.74l-45.13.07c-1.89,0-3.44-1.66-3.44-3.73Z"
      fill="#c8bda8"
      fill-rule="evenodd"
      stroke-width="0"
    />
    <path
      d="m77.85,81.65c0-2.07,1.53-3.74,3.43-3.74h6.31c1.89-.01,3.44,1.65,3.44,3.72s-1.53,3.74-3.43,3.74h-6.31c-1.89.01-3.44-1.65-3.44-3.72Z"
      fill="#c8bda8"
      fill-rule="evenodd"
      stroke-width="0"
    />
    <path
      d="m58.3,52.44c0-2.07,1.53-3.74,3.43-3.74l25.82-.04c1.89,0,3.44,1.66,3.44,3.73,0,2.07-1.53,3.74-3.43,3.74l-25.82.04c-1.89,0-3.44-1.66-3.44-3.73Z"
      fill="#c8bda8"
      fill-rule="evenodd"
      stroke-width="0"
    />
    <path
      d="m31.1,32.48l-16.77.03c-.48,0-.83-.07-1.06-.22-.21-.16-.3-.42-.3-.76v-3.27c0-.34.1-.58.29-.73.22-.16.58-.24,1.06-.24h4.26s-.01-9.05-.01-9.05h-3.5c-.48,0-.83-.07-1.06-.22-.21-.16-.3-.42-.3-.76v-3.26c0-.34.1-.58.29-.73.22-.16.58-.24,1.06-.24l11-.02c.48,0,.82.07,1.03.24.22.15.34.39.34.73l.02,13.3h3.65c.48,0,.82.07,1.03.23.22.15.34.39.34.73v3.27c0,.34-.11.6-.34.76-.21.15-.55.22-1.03.22h0Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m50.72,61.71l-16.93.03c-.45,0-.79-.07-1-.22-.19-.16-.28-.42-.28-.76v-4.66c0-1.04.12-1.9.38-2.57.28-.68.67-1.25,1.17-1.68.49-.43,1.09-.78,1.78-1.03.68-.25,1.43-.48,2.25-.66l4.76-1.14c.39-.07.62-.18.74-.33.15-.15.21-.36.21-.66,0-.27-.08-.45-.21-.54-.15-.1-.39-.16-.74-.16h-7.72c-.45.01-.79-.06-1-.21-.19-.16-.28-.42-.28-.76v-3.17c0-.34.08-.58.28-.73.21-.16.55-.24,1-.24l10.49-.02c2.02,0,3.56.38,4.63,1.15,1.09.76,1.64,1.87,1.64,3.33v2.54c0,1.35-.48,2.4-1.48,3.11-1,.73-2.35,1.28-4.06,1.69l-4.83,1.17c-.36.07-.61.15-.74.24-.12.09-.18.28-.18.57v.57s10.15-.02,10.15-.02c.45,0,.77.07.97.24.21.15.33.39.33.73v3.17c0,.34-.1.6-.32.76-.19.15-.51.22-.97.22v.03Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m53.32,85.84h8.96c.57-.01.94-.09,1.1-.25.16-.16.25-.36.25-.57v-.73c0-.22-.09-.4-.25-.54-.16-.16-.54-.24-1.1-.24h-6.07c-.45,0-.79-.06-1-.21-.19-.16-.28-.42-.28-.76v-2.9c0-.34.08-.58.28-.73.21-.16.55-.24,1-.24h3.75c.57,0,.94-.08,1.1-.25.16-.16.25-.36.25-.57v-.4c0-.22-.09-.4-.25-.57-.16-.16-.54-.24-1.1-.24h-6.64c-.45.01-.79-.06-1-.21-.19-.16-.28-.42-.28-.76v-3.23c0-.34.08-.58.28-.73.21-.16.55-.24,1-.24h9.97c1.98-.02,3.44.34,4.39,1.03.98.68,1.46,1.62,1.46,2.81v1.58c0,.68-.14,1.28-.46,1.79-.31.51-.86.88-1.64,1.13,1.7.15,2.86.53,3.5,1.19.67.62,1,1.55,1,2.74v2.71c0,1.38-.57,2.49-1.75,3.31-1.16.79-2.88,1.19-5.18,1.2l-11.28.02c-.45,0-.79-.07-1-.22-.19-.16-.28-.42-.28-.76v-3.17c0-.34.08-.58.28-.73.21-.16.55-.24,1-.24v-.03Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const AlertIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <path
      d="m38.73,15.04c-5.4,0-9.21.9-11.78,1.93-1.28.51-2.24,1.04-2.92,1.51-.34.23-.61.44-.82.61-.1.08-.2.16-.27.23-.04.03-.07.06-.1.08l-.04.04h-.01v.03l2.69,2.71-2.69-2.69c-.72.72-1.11,1.68-1.11,2.69v62.98c0,2.1,1.71,3.81,3.81,3.81s3.81-1.71,3.81-3.81v-21.1c.16-.07.32-.14.51-.21,1.58-.63,4.4-1.38,8.94-1.38,4.13,0,7.63,1.35,11.85,3.05l.21.08c4.03,1.61,8.76,3.5,14.47,3.5,5.4,0,9.21-.9,11.78-1.93,1.28-.51,2.24-1.04,2.92-1.51.34-.23.61-.44.82-.61.1-.08.2-.16.27-.23.04-.03.07-.06.1-.08l.04-.04h.01v-.03l-2.69-2.71,2.69,2.69c.72-.72,1.11-1.68,1.11-2.69V22.16c0-1.54-.93-2.93-2.36-3.53-1.38-.58-2.96-.28-4.06.73-.03.01-.08.07-.2.14-.25.17-.73.45-1.52.78-1.58.63-4.4,1.38-8.94,1.38-4.13,0-7.63-1.35-11.85-3.05l-.21-.08c-4.03-1.61-8.76-3.5-14.47-3.5h.01Zm-9.44,40.93v-31.71c.16-.07.32-.14.51-.21,1.58-.63,4.4-1.38,8.94-1.38,4.13,0,7.63,1.35,11.85,3.05l.21.08c4.03,1.61,8.76,3.5,14.47,3.5,3.96,0,7.07-.48,9.45-1.14v31.71c-.16.07-.32.14-.51.21-1.58.63-4.4,1.38-8.94,1.38-4.13,0-7.63-1.35-11.85-3.05l-.21-.08c-4.03-1.61-8.76-3.5-14.47-3.5-3.96,0-7.07.48-9.45,1.14Z"
      fill="#c8bda8"
      fill-rule="evenodd"
      stroke-width="0"
    />
  </svg>
)

const WordIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
    <rect width="104" height="104" fill="none" stroke-width="0" />
    <path
      d="m79.92,91H24.08c-6.12,0-11.08-4.97-11.08-11.08V24.08c0-6.12,4.97-11.08,11.08-11.08h55.83c6.12,0,11.08,4.97,11.08,11.08v55.83c0,6.12-4.97,11.08-11.08,11.08ZM24.08,20.39c-2.04,0-3.69,1.66-3.69,3.69v55.83c0,2.04,1.66,3.69,3.69,3.69h55.83c2.04,0,3.69-1.66,3.69-3.69V24.08c0-2.04-1.66-3.69-3.69-3.69H24.08Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m76.43,79.51H27.57c-1.68,0-3.06-1.37-3.06-3.06V27.54c0-1.68,1.37-3.06,3.06-3.06h48.86c1.68,0,3.06,1.37,3.06,3.06v48.92c0,1.68-1.36,3.06-3.06,3.06Zm-45.8-6.1h42.75V30.58H30.63v42.81h0Z"
      fill="#c8bda8"
      stroke-width="0"
    />
    <path
      d="m59.13,65.71c-1.32,0-2.48-.84-2.9-2.08l-4.02-12.07-4.02,12.07c-.43,1.27-1.58,2.13-2.99,2.08-1.34-.04-2.51-.95-2.87-2.25l-5.81-21.32c-.44-1.63.52-3.31,2.14-3.75,1.63-.44,3.31.52,3.75,2.14l3.15,11.59,3.72-11.19c.41-1.24,1.58-2.08,2.9-2.08s2.48.84,2.9,2.08l3.72,11.19,3.15-11.59c.44-1.63,2.13-2.59,3.75-2.14,1.63.44,2.59,2.13,2.14,3.75l-5.81,21.32c-.35,1.3-1.52,2.22-2.87,2.25h-.09.03Z"
      fill="#c8bda8"
      stroke-width="0"
    />
  </svg>
)

const FeatureCard = ({
  title,
  description,
  icon,
  hasPatent,
  liveDemoText = 'ライブデモを試す',
  liveDemoLink = '#',
  showLiveDemo = true
}) => {
  // descriptionがHTML文字列の場合の処理
  const renderDescription = () => {
    if (typeof description === 'string' && description.includes('<')) {
      return <div dangerouslySetInnerHTML={{ __html: description }} />
    }
    return description
  }
  return (
    <div className="relative w-full flex-1 min-w-0 px-8 py-6 lg:py-10 bg-white rounded-lg border border-solid border-gray flex flex-col justify-start items-center gap-6 overflow-hidden">
      {/* アイコン */}
      <div className="w-24 h-24 relative">{icon}</div>

      {/* タイトル */}
      <h3 className="text-base font-bold text-primary lg:text-2xl font-feature-settings">
        {title}
      </h3>

      {/* 説明文 */}
      <p className="text-sm text-textblack sm:mt-3 lg:text-base font-feature-settings">
        {renderDescription()}
      </p>

      {/* ライブデモリンク - showLiveDemoがtrueの場合のみ表示 */}
      {showLiveDemo && (
        <a
          href={liveDemoLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-center text-primary font-normal font-feature-settings hover:underline cursor-pointer"
        >
          {liveDemoText}
        </a>
      )}

      {/* 特許技術リボン */}
      {hasPatent && (
        <div className="absolute top-0 right-0">
          <div
            className="w-0 h-0 border-solid border-transparent"
            style={{
              borderWidth: '0 70px 70px 0',
              borderColor: 'transparent #4E7AC7 transparent transparent'
            }}
          />
          <div
            className="absolute z-10 text-white text-xs font-bold whitespace-nowrap"
            style={{
              top: '16px',
              right: '2px',
              transform: 'rotate(45deg)'
            }}
          >
            特許技術
          </div>
        </div>
      )}
    </div>
  )
}

const FunctionsMain = () => {
  const { pushGa4ClickEvent } = useCLickEvent()

  // 機能データ
  const features = [
    {
      title: 'データベース化',
      description: (
        <>
          文書データをドラッグ&ドロップ
          <br />
          するだけで、DB化
        </>
      ),
      icon: <DatabaseIcon />,
      hasPatent: false,
      showLiveDemo: false
    },
    {
      title: 'ナレッジAIレビュー機能',
      description: (
        <>
          自社ナレッジから自社の特殊性も
          <br />
          反映できるAIレビュー機能
        </>
      ),
      icon: <AIIcon />,
      hasPatent: false,
      liveDemoLink: '/demo/008/?from=functions'
    },
    {
      title: '類似ドキュメント検索',
      description: (
        <>
          DBの中から類似文書を
          <br />
          AIが似ている順に自動リストアップ
        </>
      ),
      icon: <SearchIcon />,
      hasPatent: false,
      liveDemoLink: '/demo/006/?from=functions'
    },
    {
      title: '不足条項の提案',
      description: (
        <>
          いつも入れている条項を
          <br />
          AIが指摘して抜け漏れ防止
        </>
      ),
      icon: <PuzzleIcon />,
      hasPatent: true,
      liveDemoLink: '/demo/003/?from=functions'
    },
    {
      title: '編集変更履歴の管理',
      description: (
        <>
          編集履歴が自動保存され、
          <br />
          最新バージョンの管理もカンタン
        </>
      ),
      icon: <HistoryIcon />,
      hasPatent: false,
      liveDemoLink: '/demo/004/?from=functions'
    },
    {
      title: '文書差分比較',
      description: (
        <>
          過去と最新バージョンの比較や
          <br />
          対案の変更箇所もパッと可視化
        </>
      ),
      icon: <CompareIcon />,
      hasPatent: false,
      liveDemoLink: '/demo/002/?from=functions'
    },
    {
      title: '自動体裁補正',
      description: (
        <>
          インデントや条番号の
          <br />
          ズレを自動で補正
        </>
      ),
      icon: <NumberIcon />,
      hasPatent: true,
      liveDemoLink: '/demo/010/?from=functions'
    },
    {
      title: '表記ゆれアラート',
      description: (
        <>
          「または」と「又は」など
          <br />
          不統一な箇所をAIが通知
        </>
      ),
      icon: <AlertIcon />,
      hasPatent: false,
      showLiveDemo: false
    },
    {
      title: '新旧対照表の作成',
      description: (
        <>
          新旧対照表を数クリックで
          <br />
          Wordに出力可能
        </>
      ),
      icon: <WordIcon />,
      hasPatent: false,
      liveDemoLink: '/demo/009/?from=functions'
    }
  ]

  return (
    <section>
      <div className="w-full max-w-[1200px] mx-auto px-6 xl:px-0 pt-16 pb-0 lg:pt-32 text-center">
        {/* タイトル */}
        <h2 className="text-lg font-bold text-textblack lg:text-4xl font-feature-setting">
          主な機能
        </h2>

        {/* カードグリッド - PCで3列、タブレットで2列、モバイルで1列 */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              hasPatent={feature.hasPatent}
              liveDemoLink={feature.liveDemoLink}
              showLiveDemo={feature.showLiveDemo}
            />
          ))}
        </div>

        {/* すべてのデモを見るボタン */}
        <div className="mt-4 lg:mt-16">
          <LinkButton
            href="/demo/?from=functions"
            size="xlarge"
            bg="visible"
            label="すべてのデモを見る"
            onClick={() => {
              pushGa4ClickEvent({
                eventCategory: 'demo',
                eventUi: 'function-button'
              })
            }}
          />
        </div>
      </div>
    </section>
  )
}

export default FunctionsMain
